import React from 'react';
import { CTAButton } from './CTAButton';
export function PainSection() {
  return <section className="bg-[#0F241C] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-124">
      <div className="max-w-2xl mx-auto" data-id="element-125">
        <h2 className="text-xl md:text-2xl font-black text-white mb-3 text-center leading-tight" data-id="element-126">
          Si enseñás producción forestal… esto te pasa.
        </h2>

        <div className="bg-[#102A1F] border border-[#1F3D2B] rounded-xl p-3 md:p-4 shadow-xl" data-id="element-127">
          <p className="text-sm md:text-base text-[#BFC9C5] font-medium mb-2 leading-snug text-center" data-id="element-128">
            Terminás una clase… y ya tenés que pensar la siguiente. Buscás
            información en distintos lados. Intentás explicar procesos técnicos.
            Tenés que bajar contenido complejo a algo que los alumnos entiendan.
          </p>
          <p className="text-sm md:text-base text-[#BFC9C5] font-medium mb-3 leading-snug text-center" data-id="element-129">
            Intentás organizar todo… pero nunca termina de cerrar. Y al final…
          </p>

          <div className="bg-red-900/20 border-l-4 border-red-500 p-2 mb-3" data-id="element-130">
            <p className="text-base md:text-lg font-black text-red-400 text-center" data-id="element-131">
              👉 Terminás improvisando.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-3" data-id="element-132">
            {['No tenés material forestal estructurado', 'Todo lo tenés que adaptar vos', 'Perdés horas todas las semanas', 'No sabés cómo llevar la teoría a la práctica'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#0B1F17] p-2 rounded-lg border border-[#1F3D2B]" data-id="element-133">
                <span className="text-red-500/80 text-xs flex-shrink-0" data-id="element-134">
                  ❌
                </span>
                <span className="text-[#BFC9C5] font-bold text-xs md:text-sm leading-tight" data-id="element-135">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-sm text-[#BFC9C5] font-medium mb-2 text-center" data-id="element-136">
            Y eso no solo te consume tiempo…
          </p>

          <div className="bg-[#0B1F17] rounded-lg p-2 text-center mb-3 border border-[#D4A843]/30" data-id="element-137">
            <p className="text-[#D4A843] font-black text-sm md:text-base" data-id="element-138">
              👉 Te hace enseñar por debajo de tu nivel.
            </p>
          </div>

          <p className="text-lg md:text-xl font-black text-white text-center mb-4" data-id="element-139">
            ❗ ¿Cuántas clases más vas a seguir improvisando?
          </p>

          <div className="flex justify-center" data-id="element-140">
            <CTAButton variant="primary" className="text-sm" data-id="element-141">
              QUIERO DEJAR DE IMPROVISAR
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}